import http from "../../http-common";

export default class ImpexiumUserInfo {
  getUserByEmail(email: string) {
    let url = `/impexium/user?email=${encodeURIComponent(email)}`;

    return http.get(url);
  }
}